// One diverging scale for "how much is this book's number worth against ours",
// used by the chips in the list and the strip's tooltip. (The strip's dots are
// coloured by cohort instead; a trailing book is drawn hollow.) Green when our
// frozen line beats the book, amber when it trails, neutral grey when the two
// agree — the same steps as `BookmakerTable`'s chip classes, which is the
// point: a book's tooltip and its row must not be different colours.
// Points of de-vigged line, not probability: this scale shades the tooltip and
// the panel chips, which are descriptive and are placed on a points axis. The
// card's bands are probability and live in `EDGE_BANDS`; the two are different
// questions and deliberately do not share a ladder.
//
// Half a point is where a book stops agreeing with us in any practical sense,
// so the steps sit either side of it.
export const FAVOUR_BANDS = { faint: 0.2, warm: 0.5, strong: 1 };

export const EDGE_TONES = {
  none: "#64748b",
  zero: "#93a7bd",
  neg1: "#b8712f",
  neg2: "#e08a3c",
  pos1: "#2c9c74",
  pos2: "#2fbd88",
  pos3: "#37dc9e",
  pos4: "#7df3c0",
};

/**
 * @param row a `rankBooks` row — shaded on `favour`, the same de-vigged number
 *            that places the dot, so a dot's colour and its position can never
 *            tell different stories.
 */
export function edgeTone(row) {
  if (!row || row.favour == null) return EDGE_TONES.none;
  const gained = Math.abs(row.favour);
  if (gained < 1e-9) return EDGE_TONES.zero;
  if (row.favour < 0) return gained < FAVOUR_BANDS.warm ? EDGE_TONES.neg1 : EDGE_TONES.neg2;
  if (gained < FAVOUR_BANDS.faint) return EDGE_TONES.pos1;
  if (gained < FAVOUR_BANDS.warm) return EDGE_TONES.pos2;
  if (gained < FAVOUR_BANDS.strong) return EDGE_TONES.pos3;
  return EDGE_TONES.pos4;
}
